import CalendarDatePicker from "ui/components/comp-507";
import UserCombobox from "components/directus/combobox/user";

import React from "react";
import { EMPLOYEE_FILTERS } from "components/employee/constants";

const TimesheetUnlockFilters = ({ filters, setFilters }) => {
  const handleDateRangeChange = (dateRange) => {
    setFilters({
      ...filters,
      date: {
        _gte: dateRange?.from || undefined,
        _lte: dateRange?.to || undefined,
      },
    });
  };

  const dateRange = {
    from: filters.date?._gte,
    to: filters.date?._lte,
  };
  return (
    <div className="flex gap-4 w-full item-center">
      <UserCombobox
        name="employee"
        value={filters.employee}
        onChange={(value) => setFilters({ ...filters, employee: value })}
        className="w-[300px]"
        placeholder="Select employee"
        hideLabel={true}
        filter={EMPLOYEE_FILTERS.all}
      />
      <CalendarDatePicker
        date={dateRange}
        setDate={handleDateRangeChange}
        placeholder="Pick a date range"
      />
    </div>
  );
};

export default TimesheetUnlockFilters;
